var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.55556C2.82812 5.55556 3.5 6.20255 3.5 7C3.5 7.79745 2.82812 8.44444 2 8.44444C1.17187 8.44444 0.5 7.79745 0.5 7C0.5 6.20255 1.17187 5.55556 2 5.55556ZM0.499999 1.94444C0.5 2.7419 1.17187 3.38889 2 3.38889C2.82812 3.38889 3.5 2.7419 3.5 1.94444C3.5 1.14699 2.82812 0.5 2 0.5C1.17187 0.5 0.499999 1.14699 0.499999 1.94444ZM0.5 12.0556C0.5 12.853 1.17187 13.5 2 13.5C2.82812 13.5 3.5 12.853 3.5 12.0556C3.5 11.2581 2.82812 10.6111 2 10.6111C1.17187 10.6111 0.5 11.2581 0.5 12.0556Z",
    fill: "#30307D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipsis);
export default __webpack_public_path__ + "static/media/elipsis.5ec6e12157e4e82543a26227c9109dbc.svg";
export { ForwardRef as ReactComponent };